import clsx from 'clsx';
import { ComponentProps, FC, ReactNode } from 'react';

import { Icon } from 'src/general/Icons/Icon';
import { ConditionalWrapper } from 'src/general/components/ConditionalWrapper/ConditionalWrapper';
import { Link } from 'src/general/components/Link/Link';

import { Shade } from '../Shade/Shade';

interface Props {
  label: ReactNode;
  href?: string;
  testid?: string;
  disabled?: boolean;
  onDelete?: () => void;
}

const rootClasses = clsx(
  'c-fs-overline c-shade_container c-shade_container--grey text-decoration-none relative inline-flex h-10 cursor-pointer items-center justify-center overflow-hidden rounded-full border border-bor-neu-bas bg-for-neu-tie1 px-3 py-0 text-tex-def-tie1 no-underline shadow-elevation-2dp hover:border-bor-neu-emp',
);

export const Chip: FC<Props> = ({ label, href, testid, disabled, onDelete }) => {
  const wrapperAlternate: ComponentProps<typeof ConditionalWrapper>['wrapperAlternate'] = (children) =>
    href ? (
      <Link href={href} data-testid={testid} className={rootClasses}>
        {children}
      </Link>
    ) : (
      <button data-testid={testid} className={rootClasses} onClick={onDelete}>
        {children}
      </button>
    );

  return (
    <ConditionalWrapper condition={!!disabled || !href} wrapper={wrapper} wrapperAlternate={wrapperAlternate}>
      {label}
      <div className="-mr-1 ml-1.5">
        <Icon name="circle-cross-filled" data-testid="chip-delete" />
      </div>
      <Shade noBackground />
    </ConditionalWrapper>
  );
};

const wrapper: ComponentProps<typeof ConditionalWrapper>['wrapper'] = (children) => (
  <span className={rootClasses}>{children}</span>
);
